import { NavLink, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import {
  CertificateListTable,
  CertificateTableFilters,
  useDefaultVbsCertificateListRequest,
} from "@/services/backend/vbs/certificates/components/certificate-list-table";
import { NewCertificateButton } from "@/services/backend/vbs/certificates/components/new-certificate-button";
import t from "@/lang/lang";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";

export function CertificatesIndexRoute() {
  const { processId } = useParams();
  const [request, setRequest] = useState(
    useDefaultVbsCertificateListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  return (
    <MilestonePage>
      <MilestonePageHeader>
        <MilestonePageTitle>{t("Zertifikate")}</MilestonePageTitle>
      </MilestonePageHeader>
      <MilestonePageContent>
        <div className="grid gap-2">
          <div className="flex justify-between">
            <CertificateTableFilters
              request={request}
              onRequestChange={setRequest}
            />
            <NewCertificateButton processId={processId!} />
          </div>
          <CertificateListTable
            request={request}
            onRequestChange={setRequest}
            renderRowLink={renderRowLink}
          />
        </div>
      </MilestonePageContent>
    </MilestonePage>
  );
}
